import React, { useContext, useState } from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import uiConstants from 'config/constants/ui'
import { useOrganization } from 'src/core/graphql/hooks'
import EventListBlock from 'src/sites/kits/Events/components/ListBlock'
import InitiativeAppMoreControl from 'src/sites/kits/Initiative/components/AppMoreControl'
import ObjectCreateControl from 'src/sites/kits/Object/components/CreateControl'
import { BackButton, Title, Titlebar, ViewModeSwitchControl } from 'src/sites/kits/UI'
import { InitiativeHierarchyContext } from 'src/sites/kits/Utils/InitiativeHierarchy'

const DynamicViewPageEvents = ({ backButtonUrl, paddingLeft, paddingRight }) => {
   const [viewMode, setViewMode] = useState(uiConstants.viewModes.GRID)
   const { initiative } = useContext(InitiativeHierarchyContext)
   const { organization } = useOrganization()
   const eventInitiativeTypes = organization.initiativeTypes
      .filter(t => t.enabled && t.class === 'event')

   return (
      <>
         <Titlebar paddingLeft={paddingLeft} paddingRight={paddingRight}>
            <View display="flex">
               {backButtonUrl && <BackButton linkTo={backButtonUrl} />}
               <Title size="md">
                  Events
               </Title>
            </View>
            <View display="flex">
               <ViewModeSwitchControl
                  currentViewMode={viewMode}
                  onListButtonClick={() => setViewMode(uiConstants.viewModes.ROW)}
                  onGridButtonClick={() => setViewMode(uiConstants.viewModes.GRID)}
               />
               {initiative.currentUserCanEdit && (
                  <View display="block" width="5px" height="30px" />
               )}
               <ObjectCreateControl
                  initiativeTypes={eventInitiativeTypes}
                  parentInitiativeId={initiative.id}
               />
               <InitiativeAppMoreControl
                  appName="Events"
                  appEnabledFieldName="appsEventsEnabled"
               />
            </View>
         </Titlebar>
         <EventListBlock
            paddingLeft={paddingLeft}
            paddingRight={paddingRight}
            parentInitiativeId={initiative.id}
            viewModeGridNumColumns="1[a] 2[b-d] 3[e-f]"
         />
      </>
   )
}

DynamicViewPageEvents.propTypes = {
   backButtonUrl: PropTypes.string,
   paddingLeft: PropTypes.string,
   paddingRight: PropTypes.string
}

DynamicViewPageEvents.defaultProps = {
   backButtonUrl: undefined,
   paddingLeft: undefined,
   paddingRight: undefined
}

export default DynamicViewPageEvents
